import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { EnvironmentLoaderService } from './environment-loader.service';
import { GetConnectorsOnLocationResponse } from 'src/app/features/charging-station-location/charging-station-location-model';
import { Moment } from 'moment';

@Injectable({
  providedIn: 'root',
})
export class ConnectorPictureService {
  private environmentLoaderService = inject(EnvironmentLoaderService);
  private httpClient = inject(HttpClient);

  apiUrl: string;
  constructor() {
    this.apiUrl = `${this.environmentLoaderService.config['serviceBaseUrl']}/api/v1/admin/`;
  }

  public getConnectorsOnLocation(locationId: string): Observable<GetConnectorsOnLocationResponse> {
    return this.httpClient.get<GetConnectorsOnLocationResponse>(`${this.apiUrl}ConnectorPicture/${locationId}'/connectors`);
  }

  public getConnectorPictureTakenDay(id: string) {
    return this.httpClient.get<string>(`${this.apiUrl}ConnectorPicture/${id}/takenDate`);
  }

  public uploadConnectorPicture(id: string, file: File, date?: Moment) {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    if (date) {
      formData.append('pictureTakenDate', date.toDate().toUTCString());
    }
    return this.httpClient.post(`${this.apiUrl}ConnectorPicture/${id}`, formData);
  }
}
